import cloneDeep from 'lodash/cloneDeep';
import {
  numberStartsWithDollarSign,
  numberToPercent,
  numberWithCommas,
} from '@/utils/string-utils';

/**
 * set ticks of the chart option's scales,
 * then, the y axis would calculate the min and max based on the suggestedMin and suggestedMax
 * charts would look much nicer
 *
 * @param {*} data
 * @param {*} options the chart options
 */
export const setTicksMaxMin = (data, options) => {
  const opts = cloneDeep(options);
  opts.scales.yAxes[0].ticks.suggestedMin = parseInt(
    Math.min(...data.datasets[0].data) * 0.85,
    10
  );
  opts.scales.yAxes[0].ticks.suggestedMax = parseInt(
    Math.max(...data.datasets[0].data) * 1.1,
    10
  );
  return opts;
};

export const setTicksMin = (data, options) => {
  const opts = cloneDeep(options);
  opts.scales.yAxes[0].ticks.min = parseInt(
    Math.min(...data.datasets[0].data),
    10
  );
  return opts;
};

export const setTicksMaxAndStepSize = (data, options) => {
  const opts = cloneDeep(options);
  opts.scales.yAxes[0].ticks.suggestedMax = parseInt(
    Math.max(...data.datasets[0].data) * 1.25,
    10
  );
  opts.scales.yAxes[0].ticks.stepSize = parseInt(
    opts.scales.yAxes[0].ticks.suggestedMax / 5,
    10
  );
  return opts;
};

/**
 *
 * @param {*} tooltipItem
 */
export const tooltipLabelCB = (tooltipItem, unit) => {
  let customLabel = '';
  if (unit === '$') {
    customLabel = `${numberStartsWithDollarSign(
      numberWithCommas(tooltipItem.value)
    )}`;
  } else if (unit === '%') {
    customLabel = `${numberToPercent(numberWithCommas(tooltipItem.value))}`;
  } else if (unit === '') {
    customLabel = `${numberWithCommas(tooltipItem.value)}`;
  }
  return customLabel;
};
